import { LetterConfig } from '@/types/types';

const LETTERS_CONFIGS: Record<string, LetterConfig> = {
  bookCases: {
    us: {
      subtitle: '(Bafsy) Запрос на книгу кейсов (pop-up)',
      recipients: [],
    },
    user: {
      subtitle: '(PDF) Книга кейсов Bafsy по Вашему запросу',
      content: [
        {
          text: 'Здравствуйте!',
          beginLine: true,
          endLine: true,
          bold: false,
          link: false,
          linkUrl: '',
        },
        {
          text: 'В ближайщее время мы свяжемся с Вами и пришлём ',
          beginLine: true,
          endLine: false,
          bold: false,
          link: false,
          linkUrl: '',
        },
        {
          text: 'книгу кейсов Bafsy.',
          beginLine: false,
          endLine: true,
          bold: true,
          link: false,
          linkUrl: '',
        },
        {
          text: 'С удовольствием проведем для вас живую демонстрацию работы и возможностей платформы. Напишите нам, чтобы выбрать удобное время.',
          beginLine: true,
          endLine: true,
          bold: false,
          link: false,
          linkUrl: '',
        },
      ],
    },
  },
  projectImplementation: {
    us: {
      subtitle: '(Bafsy) Заявка / Предложить детальный план реализации проекта',
      recipients: [],
    },
    user: {
      subtitle: 'Ваша заявка принята!',
      content: [
        {
          text: 'Здравствуйте!',
          beginLine: true,
          endLine: true,
          bold: false,
          link: false,
          linkUrl: '',
        },
        {
          text: 'Мы свяжемся с вами в ближайшее время для выбора удобного времени встречи.',
          beginLine: true,
          endLine: true,
          bold: false,
          link: false,
          linkUrl: '',
        },
      ],
    },
  },
  quiz: {
    us: {
      subtitle: '(Bafsy) Заявка / Прохождение квиза',
      recipients: [],
    },
    user: {
      subtitle: '',
      content: [],
    },
  },
  subscribeToNews: {
    us: {
      subtitle: '(Bafsy) Подписка на новостную Email-рассылку',
      recipients: [],
    },
    user: {
      subtitle: 'Вы успешно подписались на новости Bafsy',
      content: [
        {
          text: 'Здравствуйте!',
          beginLine: true,
          endLine: true,
          bold: false,
          link: false,
          linkUrl: '',
        },
        {
          text: 'Вы успешно подписались на новости Bafsy.',
          beginLine: true,
          endLine: true,
          bold: false,
          link: false,
          linkUrl: '',
        },
      ],
    },
  },
};

export { LETTERS_CONFIGS };
